/*@ngInject*/
const RepeatingFormDynamicDataSetFormSetIdRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getOwningFormSetId = function (formId, dynamicDataSetName) {
        let url = '/rest/DataSet/repeatingDynamicDataSetFormSetId',
            config = {
                params: {
                    formId: formId,
                    dynamicDataSetName: dynamicDataSetName
                }
            };

        return this.get(url, config);
    };
};

angular.module('umCore')
    .service('repeatingFormDynamicDataSetFormSetIdRepository', RepeatingFormDynamicDataSetFormSetIdRepository);
